import type { ChatPerson } from "./types";

/** A chat person as an `AvatarTile`/`AvatarStack` item (no `src` key without a photo). */
export function toAvatar(p: ChatPerson) {
  return {
    name: p.name,
    kind: p.kind === "agent" ? ("agent" as const) : ("person" as const),
    ...(p.avatarUrl ? { src: p.avatarUrl } : {}),
  };
}
